module.exports = __webpack_public_path__ + "media/cookies/cookie-checked-c43abf19.svg";